import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonSquareGroup } from '@yme/atoms/button-select/ButtonSquareGroup';
import { NA_VALUE } from '@yme/common/constants';
import { setFilterOptions, getProductValueByOption } from '@yme/pdp-components/ProductCard';
import { getProductLoweredVersionLocaleName } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, } from '../constants';
import { buildRadioButtonsOptionsList } from '../helpers';
import { LOWERED_VERSION_DATA_TEST_ID, LOWERED_VERSION_FILTER_KEY } from './constants';
import { getAvailableSkuByLoweredVersionValue, getPossibleSLoweredVersionOptions, getSortedLoweredVersionVariationsValues, } from './helpers';
export function SelectLoweredVersion({ productFilterOptions, variantsOfProduct, }) {
    const productLoweredVersionValues = useSelector(getProductValueByOption(LOWERED_VERSION_FILTER_KEY));
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const loweredVersionName = useSelector(getProductLoweredVersionLocaleName);
    const { sku, power = '', transmission = '', loweredVersion = '' } = productFilterOptions;
    const onSelectNewValue = useCallback((value) => {
        if (value && loweredVersion !== value) {
            const currentVariant = getAvailableSkuByLoweredVersionValue({
                colorVariants: variantsOfProduct,
                loweredVersionValue: value,
                transmissionValue: transmission,
                powerValue: power,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    loweredVersion: currentVariant.loweredVersion || value,
                    // set relative options
                    sku: currentVariant.sku,
                    power: currentVariant.power,
                    transmission: currentVariant.transmission,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, loweredVersion, power, sku, transmission, variantsOfProduct]);
    const isCurrentFilterExist = productLoweredVersionValues?.some((item) => item.trim().length > 0) ?? false;
    if (isCurrentFilterExist && loweredVersion !== NA_VALUE) {
        const preparedLoweredVersionList = buildRadioButtonsOptionsList(productLoweredVersionValues);
        const sortedLoweredVersionList = getSortedLoweredVersionVariationsValues(preparedLoweredVersionList, loweredVersionName);
        const possibleOptions = (variantsOfProduct &&
            getPossibleSLoweredVersionOptions(variantsOfProduct, power, transmission)) ||
            [];
        return (React.createElement(FlexWrapper, { mt: "24px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px", gap: "4px" },
                React.createElement(RegularTextLevel3, { as: "span", weight: 500 }, t('productCard_loweredVersion_label'))),
            React.createElement(FlexWrapper, { flexDirection: "row", gap: "8px", flexWrap: "wrap", minHeight: "44px" },
                React.createElement(ButtonSquareGroup, { contentTag: RegularTextLevel4, defaultContentStyles: DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, activeContentStyles: ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, setActiveOption: onSelectNewValue, allOptions: sortedLoweredVersionList, possibleOptions: possibleOptions, selectedValue: loweredVersion, dataTestId: LOWERED_VERSION_DATA_TEST_ID }))));
    }
    return null;
}
